<template>
  <div class="manage--content" ref="lesson-content">
    <div class="primarylists nqt__priList">
      <button class="btn-tast btn-next-1" v-if="mobile" @click="back()">
        <span>{{ $t("common.returnButton") }}</span>
      </button>
      <div
        v-if="
          data.dataBegin.type == '1cs' ||
            data.dataBegin.type == '2cs' ||
            data.dataBegin.type == '3cs' ||
            data.dataBegin.type == '4cs'
        "
        class="select-new-questions"
      >
        <p>{{ $t("new.title227") }}</p>
        <select
          v-model="sortMB"
          @change="clickSortCourseMB()"
          class="questions_type"
          :class="{ my_select_organization_disabled: sortMB == 0 }"
        >
          <option value="0" class="ds">{{ $t("new.title140") }}</option>
          <option value="1" class="ds">{{ $t("new.title135") }}</option>
          <option value="2" class="ds">{{ $t("new.title136") }}</option>
          <option value="3" class="ds">{{ $t("new.title137") }}</option>
          <option value="4" class="ds">{{ $t("new.title138") }}</option>
          <option value="5" class="ds">{{ $t("new.title139") }}</option>
        </select>
      </div>
      <div class="title-course">
        <h1 v-if="data.dataBegin.type == '1cs'">{{ $t("new.title130") }}</h1>
        <h1 v-if="data.dataBegin.type == '2cs'">{{ $t("new.title131") }}</h1>
        <h1 v-if="data.dataBegin.type == '3cs'">{{ $t("new.title132") }}</h1>
        <h1 v-if="data.dataBegin.type == '4cs'">{{ $t("new.title133") }}</h1>
        <!-- <h1 v-if="data.dataBegin.type != '0cs'">{{ data.courseName }}</h1> -->
      </div>
      <div class="lessons lessons-new">
        <ul class="clear">
          <template v-if="listDataContent.length">
            <li
              v-for="(item, index) in listCourse"
              @click="nextPageDetailsCourse(item)"
              :key="index + 'listCourse'"
            >
              <div>
                <!-- Ảnh -->
                <div class="img vaa">
                  <template
                    v-if="item.courseCover == null || item.courseCover == ''"
                  >
                    <img src="../../../../static/images/temppic.jpg" alt="/" />
                  </template>
                  <template v-else>
                    <template v-if="item.courseCover.match(regExp)">
                      <iframe
                        width="100% !important"
                        height="100% !important"
                        :src="item.courseCover"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      >
                      </iframe>
                    </template>
                    <template v-else>
                      <img
                        :src="item.courseCover"
                        alt="/"
                        @error="setAltCourse"
                      />
                    </template>
                  </template>
                </div>
                <div>
                  <div class="lessontitle_MB">
                    <div
                      class="lessontitle"
                      style="-webkit-box-orient: vertical;"
                    >
                      {{ item.courseName }}
                    </div>
                  </div>
                  <!-- Tên khoá học -->
                  <div class="lessontitle_PC">
                    <div
                      class="lessontitle"
                      style="-webkit-box-orient: vertical;"
                    >
                      {{ item.courseName }}
                    </div>
                  </div>
                  <!-- Sao đánh giá -->
                  <span class="startIndex">
                    <div
                      class="Stars"
                      :style="'--rating:' + item.courseEvaluate"
                    ></div>
                  </span>
                  <div class="startAndPrice">
                    <!-- Giá tiền -->
                    <span v-if="item.coursePrice == 0" class="priceIndex">
                      <span class="free-course">{{ domainNameCurrent === DOMAIN_NAME ? $t("new.title291") : $t("new.title214") }}</span>
                    </span>
                    <span v-else-if="item.coursePrice < 0" class="priceIndex">
                      <span class="free-course"></span>
                    </span>
                    <span v-else class="priceIndex">
                      <template
                        v-if="
                          (item.offSelf > 0 && item.offSelf != null) ||
                            item.offSelf != ''
                        "
                      >
                        <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                        {{
                          item.coursePrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                      </template>
                      <template v-else>
                        <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                        {{
                          item.coursePrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                      </template>
                    </span>
                  </div>
                  <!-- {{ $t("new.title183") }} -->
                  <!-- <div>
                            <p class="button-sub" @click.stop="clickNextPageSubsribe(item)">{{ $t("new.title183") }}</p>
                        </div> -->
                  <div
                    v-if="
                      (item.offSelf > 0 && item.offSelf != null) ||
                        item.offSelf != ''
                    "
                    class="hot-position"
                  >
                    <div class="">
                      <span>-{{ item.offSelf }}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <!-- Phân trang -->
            <div
              class="pagination-course"
              style="text-align: center; margin-top: 10px; margin-bottom: 10px; width:100%"
            >
              <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-size="pageSize"
                layout="prev, pager, next"
                :total="listDataContent.length"
              ></el-pagination>
            </div>
          </template>
          <!-- All Course -->
          <!-- New Course -->
          <div class="title-course course-all">
            <h1
              v-if="
                data.dataBegin.type == '0cs' &&
                  listDataContent &&
                  listDataContent.encourageStudyArt &&
                  listDataContent.encourageStudyArt.length > 0
              "
            >
              {{ $t("new.title130") }}
            </h1>
          </div>
          <template>
            <li
              v-for="(item, index) in listDataContent.encourageStudyArt"
              @click="nextPageDetailsCourse(item)"
              :key="index + 'encourageStudyArt'"
            >
              <div>
                <!-- Ảnh -->
                <div class="img vaa">
                  <template
                    v-if="item.courseCover == null || item.courseCover == ''"
                  >
                    <img src="../../../../static/images/temppic.jpg" alt="/" />
                  </template>
                  <template v-else>
                    <template v-if="item.courseCover.match(regExp)">
                      <iframe
                        width="100% !important"
                        height="100% !important"
                        :src="item.courseCover"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      >
                      </iframe>
                    </template>
                    <template v-else>
                      <img
                        :src="item.courseCover"
                        alt="/"
                        @error="setAltCourse"
                      />
                    </template>
                  </template>
                </div>

                <div>
                  <div class="lessontitle_MB">
                    <div
                      class="lessontitle"
                      style="-webkit-box-orient: vertical;"
                    >
                      {{ item.courseName }}
                    </div>
                  </div>
                  <!-- Tên khoá học -->
                  <div class="lessontitle_PC">
                    <div
                      class="lessontitle"
                      style="-webkit-box-orient: vertical;"
                    >
                      {{ item.courseName }}
                    </div>
                  </div>
                  <!-- Sao đánh giá -->
                  <span class="startIndex">
                    <div
                      class="Stars"
                      :style="'--rating:' + item.courseEvaluate"
                    ></div>
                  </span>
                  <div class="startAndPrice">
                    <!-- Giá tiền -->
                    <span v-if="item.coursePrice == 0" class="priceIndex">
                      <span class="free-course">{{ domainNameCurrent === DOMAIN_NAME ? $t("new.title291") : $t("new.title214") }}</span>
                    </span>
                     <span v-else-if="item.coursePrice < 0" class="priceIndex">
                      <span class="free-course"></span>
                    </span>
                    <span v-else class="priceIndex">
                      <template
                        v-if="
                          (item.offSelf > 0 && item.offSelf != null) ||
                            item.offSelf != ''
                        "
                      >
                        <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                        {{
                          item.coursePrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                      </template>
                      <template v-else>
                        <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                        {{
                          item.coursePrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                      </template>
                    </span>
                  </div>
                  <!-- {{ $t("new.title183") }} -->
                  <!-- <div>
                           <p class="button-sub" @click.stop="clickNextPageSubsribe(item)">{{ $t("new.title183") }}</p>
                        </div> -->
                  <div
                    v-if="
                      (item.offSelf > 0 && item.offSelf != null) ||
                        item.offSelf != ''
                    "
                    class="hot-position"
                  >
                    <div class="">
                      <span>-{{ item.offSelf }}%</span>
                    </div>
                  </div>
                  <div></div>
                </div>
              </div>
            </li>
          </template>
          <!-- listCouseHot Course -->
          <div class="title-course course-all">
            <h1
              v-if="
                data.dataBegin.type == '0cs' &&
                  listDataContent &&
                  listDataContent.listCouseHot &&
                  listDataContent.listCouseHot.length > 0
              "
            >
              {{ $t("new.title131") }}
            </h1>
          </div>
          <template>
            <li
              v-for="(item, index) in listDataContent.listCouseHot"
              @click="nextPageDetailsCourse(item)"
              :key="index + 'listCouseHot'"
            >
              <div>
                <!-- Ảnh -->
                <div class="img vaa">
                  <template
                    v-if="item.courseCover == null || item.courseCover == ''"
                  >
                    <img src="../../../../static/images/temppic.jpg" alt="/" />
                  </template>
                  <template v-else>
                    <template v-if="item.courseCover.match(regExp)">
                      <iframe
                        width="100% !important"
                        height="100% !important"
                        :src="item.courseCover"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      >
                      </iframe>
                    </template>
                    <template v-else>
                      <img
                        :src="item.courseCover"
                        alt="/"
                        @error="setAltCourse"
                      />
                    </template>
                  </template>
                </div>

                <div>
                  <div class="lessontitle_MB">
                    <div
                      class="lessontitle"
                      style="-webkit-box-orient: vertical;"
                    >
                      {{ item.courseName }}
                    </div>
                  </div>
                  <!-- Tên khoá học -->
                  <div class="lessontitle_PC">
                    <div
                      class="lessontitle"
                      style="-webkit-box-orient: vertical;"
                    >
                      {{ item.courseName }}
                    </div>
                  </div>
                  <!-- Sao đánh giá -->
                  <span class="startIndex">
                    <div
                      class="Stars"
                      :style="'--rating:' + item.courseEvaluate"
                    ></div>
                  </span>
                  <div class="startAndPrice">
                    <!-- Giá tiền -->
                    <span v-if="item.coursePrice == 0" class="priceIndex">
                      <span class="free-course">{{ domainNameCurrent === DOMAIN_NAME ? $t("new.title291") : $t("new.title214") }}</span>
                    </span>
                     <span v-else-if="item.coursePrice < 0" class="priceIndex">
                      <span class="free-course"></span>
                    </span>
                    <span v-else class="priceIndex">
                      <template
                        v-if="
                          (item.offSelf > 0 && item.offSelf != null) ||
                            item.offSelf != ''
                        "
                      >
                        <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                        {{
                          item.coursePrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                      </template>
                      <template v-else>
                        <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                        {{
                          item.coursePrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                      </template>
                    </span>
                  </div>
                  <!-- {{ $t("new.title183") }} -->
                  <!-- <div>
                           <p class="button-sub" @click.stop="clickNextPageSubsribe(item)">{{ $t("new.title183") }}</p>
                        </div> -->
                  <div
                    v-if="
                      (item.offSelf > 0 && item.offSelf != null) ||
                        item.offSelf != ''
                    "
                    class="hot-position"
                  >
                    <div class="">
                      <span>-{{ item.offSelf }}%</span>
                    </div>
                  </div>
                  <div></div>
                </div>
              </div>
            </li>
          </template>
          <!-- listCouseHot Course -->
          <div class="title-course course-all">
            <h1
              v-if="
                data.dataBegin.type == '0cs' &&
                  listDataContent &&
                  listDataContent.encourageStudyArt &&
                  listDataContent.encourageStudyArt.length > 0
              "
            >
              {{ $t("new.title132") }}
            </h1>
          </div>
          <template>
            <li
              v-for="(item, index) in listDataContent.encourageStudyArt"
              @click="nextPageDetailsCourse(item)"
              :key="index + 'all'"
            >
              <div>
                <!-- Ảnh -->
                <div class="img vaa">
                  <template
                    v-if="item.courseCover == null || item.courseCover == ''"
                  >
                    <img src="../../../../static/images/temppic.jpg" alt="/" />
                  </template>
                  <template v-else>
                    <template v-if="item.courseCover.match(regExp)">
                      <iframe
                        width="100% !important"
                        height="100% !important"
                        :src="item.courseCover"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      >
                      </iframe>
                    </template>
                    <template v-else>
                      <img :src="item.courseCover" alt="/" />
                    </template>
                  </template>
                </div>
                <div>
                  <div class="lessontitle_MB">
                    <div
                      class="lessontitle"
                      style="-webkit-box-orient: vertical;"
                    >
                      {{ item.courseName }}
                    </div>
                  </div>
                  <!-- Tên khoá học -->
                  <div class="lessontitle_PC">
                    <div
                      class="lessontitle"
                      style="-webkit-box-orient: vertical;"
                    >
                      {{ item.courseName }}
                    </div>
                  </div>
                  <!-- Sao đánh giá -->
                  <span class="startIndex">
                    <div
                      class="Stars"
                      :style="'--rating:' + item.courseEvaluate"
                    ></div>
                  </span>
                  <div class="startAndPrice">
                    <!-- Giá tiền -->
                    <span v-if="item.coursePrice == 0" class="priceIndex">
                      <span class="free-course">{{ domainNameCurrent === DOMAIN_NAME ? $t("new.title291") : $t("new.title214") }}</span>
                    </span>
                     <span v-else-if="item.coursePrice < 0" class="priceIndex">
                      <span class="free-course"></span>
                    </span>
                    <span v-else class="priceIndex">
                      <template
                        v-if="
                          (item.offSelf > 0 && item.offSelf != null) ||
                            item.offSelf != ''
                        "
                      >
                        <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                        {{
                          item.coursePrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                      </template>
                      <template v-else>
                        <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                        {{
                          item.coursePrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                      </template>
                    </span>
                  </div>
                  <!-- {{ $t("new.title183") }} -->
                  <!-- <div>
                           <p class="button-sub" @click.stop="clickNextPageSubsribe(item)">{{ $t("new.title183") }}</p>
                        </div> -->
                  <div
                    v-if="
                      (item.offSelf > 0 && item.offSelf != null) ||
                        item.offSelf != ''
                    "
                    class="hot-position"
                  >
                    <div class="">
                      <span>-{{ item.offSelf }}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </template>
          <!-- listCategory Course -->
          <div class="title-course course-all">
            <h1 v-if="data.dataBegin.type == '0cs' && listCourseCat.length > 0">
              {{ $t("new.title133") }}
            </h1>
          </div>
          <template v-for="(item, index) in listCourseCat">
            <li
              class="category"
              v-if="item.parentId == '0' && data.dataBegin.type == '0cs'"
              v-on:click="changeItem({ type: 4, dataChild: item })"
              :key="index + 'listCourseCat'"
            >
              <div>
                <!-- Tên khoá học -->
                <div class="lessontitle_PC">
                  <div
                    class="catalogTitle"
                    style="-webkit-box-orient: vertical;"
                  >
                    {{ item.catalogName }}
                  </div>
                </div>
                <div class="lessontitle_MB">
                  <div
                    class="catalogTitle"
                    style="-webkit-box-orient: vertical;"
                  >
                    {{ item.catalogName }}
                  </div>
                </div>
              </div>
            </li>
          </template>
          <div
            v-if="data.dataBegin.type == '0cs' && listCourseCat.length > 0"
            class="pagination-course-category"
            style="text-align: center; margin-top: 10px; margin-bottom: 10px; width:100%"
          >
            <el-pagination
              background
              @current-change="handleCurrentChangeCat"
              :current-page="pageNumCat"
              :page-size="pageSizeCat"
              layout="prev, pager, next"
              :total="listCategory.length"
            ></el-pagination>
          </div>
        </ul>
      </div>
    </div>
    <div class="shopping-cart">
      <p class="button-icon" v-if="cart.length > 0" v-on:click="OpenModal()">
        <img src="../../../../static/images/Ellipse 5.png" alt="" /><b
          class="total-item-cart"
          >{{ cart.length }}</b
        >
      </p>
      <!-- The Modal -->
      <div id="myModal-Cart" class="modal">
        <!-- Modal content -->
        <div class="modal-content">
          <span v-on:click="CloseModal()" class="close">{{
            $t("new.title208")
          }}</span>
          <div class="cart-content">
            <div v-if="cart.length == 0">
              <img
                class="empty-cart"
                src="../../../../static/images/GHtrong2-xanh.png"
                width="150"
                alt="/"
              />
              <!-- <h3 style="text-align:center">{{ $t("new.title152") }} </h3> -->
            </div>
            <table class="cart-table" style="width:100%;">
              <tr
                id="item-course"
                v-for="(carts, index) in cart"
                :key="carts.courseId"
              >
                <td
                  class="item-image"
                  :class="{ cart_moblie: mobile }"
                  style="width:35%;text-align: -webkit-center;"
                >
                  <template
                    v-if="carts.courseCover == null || carts.courseCover == ''"
                  >
                    <img src="../../../../static/images/temppic.jpg" alt="/" />
                  </template>
                  <template v-else>
                    <template v-if="carts.courseCover.match(regExp)">
                      <iframe
                        width="100% !important"
                        height="100% !important"
                        :src="carts.courseCover"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      >
                      </iframe>
                    </template>
                    <template v-else>
                      <img
                        :src="carts.courseCover"
                        alt="/"
                        @error="setAltCourse"
                      />
                    </template>
                  </template>
                </td>
                <td
                  class="item-title"
                  :class="{ cart_moblie: mobile }"
                  style="width:55%"
                >
                  <h3
                    style="color:#0071c5;line-height:20px;word-break: break-word;"
                  >
                    {{ carts.courseName }}
                  </h3>
                  <div style="float:left">
                    <p>{{ $t("new.title145") }}:</p>
                    <p>{{ $t("new.title147") }}:</p>
                    <p v-if="carts.coursePrice >= 0">{{ $t("new.title153") }}:</p>
                  </div>
                  <div style="float:left;padding-left:10px;font-weight:600">
                    <p>{{ carts.timestudy }} {{ $t("new.title146") }}</p>
                    <p>{{ carts.totalless }} {{ $t("new.title154") }}</p>
                     <tempalte v-if="carts.coursePrice>=0">
                        <p v-if="carts.offSelf != 0" class="item-price-cart">
                           <span v-if="beforCurren">{{ $t("new.title121") }}</span
                           >{{
                              (carts.coursePrice - carts.coursePriceDiscount)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                           }}
                           <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                        </p>
                        <p v-else class="item-price-cart">
                           <span v-if="beforCurren">{{ $t("new.title121") }}</span
                           >{{
                              carts.coursePrice
                              .toString().replace('.00', '')
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                           }}
                           <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                        </p>
                    </tempalte>
                  </div>
                </td>
                <td
                  class="item-close"
                  title="bỏ khóa học"
                  style="width:10%"
                  v-on:click="
                    CloseItemCourse(
                      index,
                      carts.coursePrice - carts.coursePriceDiscount
                    )
                  "
                >
                  &#10008;
                </td>
              </tr>

              <tr v-if="cart.length > 0">
                <td colspan="3" class="item-total">
                  <p v-if="reduce>=0">
                    {{ $t("new.title155") }} :
                    <span
                      ><b
                        ><span v-if="beforCurren">{{
                          $t("new.title121")
                        }}</span>
                        {{
                          reduce
                            .toString().replace('.00', '')
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{
                          $t("new.title121")
                        }}</span></b
                      ></span
                    >
                  </p>
                </td>
              </tr>
            </table>

            <button
              v-if="cart.length > 0"
              class="submit"
              @click="NextPageSubsribeCart()"
            >
              {{ $t("new.title143") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <loading class="loading--lesson nqt-pst-a" :showLoading="!isLoadData" />
  </div>
</template>

<script>
import loading from "@/components/loading/loading";
import domainName from "../../../../env";

export default {
  data() {
    return {
      content: true,
      catalog: true,
      related: true,
      dataDetails: {},
      badge: 0,
      reduce: 0,
      listDataContent: [],
      listCategory: [],
      sortType: 0,
      sortMB: 0,
      cartadd: {},
      cart: [],
      detailCourse: [],
      afterCurren: false,
      beforCurren: false,
      pageNum: 1,
      page: 1,
      pageSize: 8,
      pageNumCat: 1,
      pageCat: 1,
      pageSizeCat: 12,
      regExp: /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/,
      isLoadData: false,
      templateYoutubeSrc: "https://www.youtube.com/embed/",
      domainNameCurrent: window.location.host,
      DOMAIN_NAME: domainName.DOMAIN_NAME_SANRITSU,
    };
  },
  components: {
    loading
  },
  computed: {
    mobile() {
      return this.$store.getters["header/mobile"];
    },
    listCourse() {
      this.pageSize = 8;
      return this.listDataContent.slice(
        this.pageSize * this.page - this.pageSize,
        this.pageSize * this.page
      );
    },
    listCourseCat() {
      this.pageSizeCat = 12;
      return this.listCategory.slice(
        this.pageSizeCat * this.pageCat - this.pageSizeCat,
        this.pageSizeCat * this.pageCat
      );
    }
  },
  props: {
    data: {
      type: Object,
      default: {},
      listData: []
    }
  },
  created() {
    if (!this.data.dataContentSeflCourse) return;
    this.listData = this.data.dataContentSeflCourse;
    this.catalogTittle = null;
    this.checkChild();
    this.checkCurren();
    this.viewCart();
    this.init();
  },
  watch: {},
  methods: {
    init: function() {
      /// check thuộc loại catalog nào để lấy data hiển thị
      if (this.data.dataBegin.type == "4cs") {
        this.listDataContent = this.data.dataTypeCatalog;
      } else {
        if (this.data.dataBegin.type == "1cs") {
          this.listDataContent = this.listData.listCourseNew;
        } else if (this.data.dataBegin.type == "2cs") {
          this.listDataContent = this.listData.listCouseHot;
        } else if (this.data.dataBegin.type == "3cs") {
          this.listDataContent = this.listData.encourageStudyArt;
        } else {
          this.listDataContent = this.listData;
        }
      }
      /// check có list và check khoá học đó được giảm giá hay không
      if (this.listDataContent) {
        if (this.listDataContent.length > 0) {
          this.listDataContent.forEach(item => {
            item.courseUpdateDate = item.courseUpdateDate.replaceAll("/", "");
            if (
              ((item.offSelf > 0 && item.offSelf != null) ||
              item.offSelf != "") && item.coursePrice > 0
            ) {
              item["priceDiscount"] =
                item.coursePrice - item.coursePriceDiscount;
              item["presentPriceCourse"] = item.coursePrice;
              item["priceSort"] = item.coursePrice - item.coursePriceDiscount;
            } else {
              item["presentPriceCourse"] = item.coursePrice;
              item["priceDiscount"] = 0;
              item["priceSort"] = item.coursePrice;
            }
            // format src type youtube
            if (item.courseCover.match(this.regExp)) {
              let temp = item.courseCover.split("https://youtu.be/");
              if (temp[1]) {
                item.courseCover = this.templateYoutubeSrc + temp[1];
              }
            }
          });
        }
      }
      this.$nextTick(() => {
        setTimeout(() => {
          this.isLoadData = true;
        }, 100);
      });
    },
    setAltCourse(event) {
      event.target.src = "../../../static/images/temppic.jpg";
    },
    /// click thay đổi nội dung khoá học
    changeItem: function(value) {
      this.checkType = value.type;
      let id = null;
      if (value.type == 4) {
        id = value.dataChild.catalogId;
      } else {
        id = value.dataChild.id;
      }
      this.data.dataBegin.catalogId = id;
      this.$emit("changeItem", value);
      document.getElementsByTagName("body")[0].classList.remove("show-menu-1");
    },
    /// Sắp xếp lại các khoá học
    clickSortCourse: function(params) {
      this.sortType = params;
      if (params == 1) {
        this.listDataContent = this.listDataContent.sort(
          (a, b) => parseFloat(b.totalStudent) - parseFloat(a.totalStudent)
        );
      } else if (params == 2) {
        this.listDataContent = this.listDataContent.sort(
          (a, b) => parseFloat(b.courseEvaluate) - parseFloat(a.courseEvaluate)
        );
      } else if (params == 3) {
        this.listDataContent = this.listDataContent.sort(
          (a, b) => parseFloat(a.priceSort) - parseFloat(b.priceSort)
        );
      } else if (params == 4) {
        this.listDataContent = this.listDataContent.sort(
          (a, b) => parseFloat(b.priceSort) - parseFloat(a.priceSort)
        );
      } else if (params == 5) {
        this.listDataContent = this.listDataContent.sort(
          (a, b) =>
            parseFloat(b.courseUpdateDate) - parseFloat(a.courseUpdateDate)
        );
      }
    },
    /// Sắp xếp lại các khoá học
    clickSortCourseMB: function() {
      let params = this.sortMB;
      this.sortType = params;
      if (params == 1) {
        this.listDataContent = this.listDataContent.sort(
          (a, b) => parseFloat(b.totalStudent) - parseFloat(a.totalStudent)
        );
      } else if (params == 2) {
        this.listDataContent = this.listDataContent.sort(
          (a, b) => parseFloat(b.courseEvaluate) - parseFloat(a.courseEvaluate)
        );
      } else if (params == 3) {
        this.listDataContent = this.listDataContent.sort(
          (a, b) =>
            parseFloat(a.presentPriceCourse) - parseFloat(b.presentPriceCourse)
        );
      } else if (params == 4) {
        this.listDataContent = this.listDataContent.sort(
          (a, b) =>
            parseFloat(b.presentPriceCourse) - parseFloat(a.presentPriceCourse)
        );
      } else if (params == 5) {
        this.listDataContent = this.listDataContent.sort(
          (a, b) =>
            parseFloat(b.courseUpdateDate) - parseFloat(a.courseUpdateDate)
        );
      }
    },
    nextPageDetailsCourse(params) {
      let id = null;
      let listId = [];
      if (this.data.dataBegin.type == "4cs") {
        id = this.data.dataBegin.catalogId;
      } else {
        if (params.catalogIds) {
          if (params.catalogIds.length > 0) {
            params.catalogIds.forEach(element => {
              listId.push(element.catalogId);
            });
          }
        }
      }
      let dataUrls = {
        type: 2,
        courseId: params.courseId,
        catalogId: id,
        listId: listId
      };
      // Đi đến chi tiết bán khóa học
      this.$router.push({
        path: "/home/detailsSelfCourse",
        query: {
          outlineInfo: JSON.stringify(dataUrls)
        }
      });
    },
    checkChild() {
      let x = 0;
      for (let index = 0; index < this.listData.listCatalog.length; index++) {
        if (this.listData.listCatalog[index].parentId == 0) {
          this.listCategory[x] = this.listData.listCatalog[index];
          x++;
        }
      }
    },
    // Curency position
    checkCurren() {
      if (this.$lang()) {
        if (this.$lang() == 3 || this.$lang() == 1) {
          this.beforCurren = true;
        } else {
          this.afterCurren = true;
        }
      }
    },
    back() {
      this.$router.push({
        path: "/home/index"
      });
    },
    toggle(value) {
      if (value == "content") {
        this.content = !this.content;
      } else if (value == "related") {
        this.related = !this.related;
      } else {
        this.catalog = !this.catalog;
      }
    },
    OpenModal() {
      document.getElementById("myModal-Cart").style.display = "block";
    },
    CloseModal() {
      document.getElementById("myModal-Cart").style.display = "none";
    },
    CloseItemCourse() {
      document.getElementById("item-course").style.display = "none";
    },
    CloseItemCourse(id, price) {
      this.cart.splice(id, 1);
      if (this.reduce > 0 && price >= 0) {
        this.reduce -= price;
      }
      this.saveCats();
    },
    //
    NextPageSubsribeCart() {
      this.$router.push({
        path: "/home/subscribeSelfCourse",
        query: {}
      });
    },
    //Paginate All
    handleCurrentChange(val) {
      this.page = val;
    },
    //Paginate Category
    handleCurrentChangeCat(val) {
      this.pageCat = val;
    },
    // Subsribe Course
    clickNextPageSubsribe(item) {
      // Lấy dữ liệu detail
      this.$api
        .post("/evaluate/getDetailsByIdCourse", {
          courseId: item.courseId,
          languageType: this.$lang()
        })
        .then(response => {
          this.detailCourse = response.data;
          // cartadd is here to get all things that click or chosen by user
          const checkUsername = obj => obj.courseId === item.courseId;
          if (this.cart.some(checkUsername) == false) {
            this.cartadd.courseId = item.courseId;
            this.cartadd.courseName = item.courseName;
            this.cartadd.coursePrice = item.coursePrice;
            this.cartadd.courseCover = item.courseCover;
            this.cartadd.timestudy = this.detailCourse.courseEstimatedStudyTime;
            this.cartadd.totalless = this.detailCourse.courseCurriculumTotal;
            this.cartadd.qty = 1;
            this.cartadd.coursePriceDiscount = item.coursePriceDiscount;
            this.cartadd.courseEvaluate = item.courseEvaluate;
            this.cartadd.offSelf = item.offSelf;
            this.cartadd.courseBankInfo = item.courseBankInfo;
            this.cart.push(this.cartadd);
            this.saveCats();
          }
          this.$router.push({
            path: "/home/subscribeSelfCourse",
            query: {
              type: this.$route.query.type,
              catalogId: this.$route.query.catalogId
            }
          });
        })
        .catch(err => {
          // console.log(err.response);
        });
    },
    saveCats() {
      // for save in local storage set the below code
      let parsed = JSON.stringify(this.cart);
      localStorage.setItem("cart_" + this.$lang(), parsed);
      this.viewCart();
    },
    viewCart() {
      if (localStorage.getItem("cart_" + this.$lang())) {
        this.cart = JSON.parse(localStorage.getItem("cart_" + this.$lang()));
        // totall price in shopping cart
        this.reduce = 0;
        for (let index = 0; index < this.cart.length; index++) {
          if (this.cart[index].coursePrice < 0) {
            continue;
          }
          if (this.cart[index].offSelf != 0 && this.cart[index].coursePrice > 0) {
            this.reduce +=
              this.cart[index].coursePrice -
              this.cart[index].coursePriceDiscount;
          } else {
            this.reduce += this.cart[index].coursePrice;
          }
        }
      }
    }
  }
};
</script>
<style scoped>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: red;
}
.manage--content {
  background: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: none;
  overflow: hidden;
  height: auto;
}
.sort_self_course {
  margin-bottom: 5px;
  background-color: #f1f1f1;
  padding: 5px 0px;
}
.item_sort {
  font-size: 15px;
}
.title-course {
  padding: 0px 20px 20px 20px;
}
.course-all {
  width: 100%;
  padding: 20px;
}
.title-course h1 {
  color: #033c7f;
}
.item_child {
  margin-right: 2vh;
  padding: 5px;
  font-size: 17px;
  cursor: pointer;
}
.item_child:hover {
  background-color: #c4c4c4;
  border-radius: 5px;
}
.sort_active {
  background-color: #ddddf3;
  border-radius: 5px;
}
.primarylists {
  padding-top: 0px;
}
.primarylists .lessons.lessons-new ul li {
  width: calc(25% - 16px) !important;
}
.primarylists .lessons.lessons-new ul .category {
  width: calc(25% - 16px) !important;
  height: auto;
  border-radius: 10px !important;
}
.primarylists .lessons.lessons-new ul .category .catalogTitle {
  font-size: 16px;
  font-weight: bold;
  padding: 15px;
}
.primarylists .lessons.lessons-new ul .category:hover {
  color: #fff;
  background-color: #0071c1 !important;
  cursor: pointer;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: red !important;
}
.lessons {
  margin-top: 0px;
}
.Stars {
  --star-size: 15px;
  --star-color: #a8a8a8;
  --star-background: #ffa60a;
  --percent: calc(var(--rating) / 5 * 100%);
  display: inline-block;
  font-size: var(--star-size);
  font-family: Times;
  line-height: 1;
  padding-left: 10px;
}
.Stars::before {
  content: "★★★★★";
  letter-spacing: 3px;
  background: linear-gradient(
    90deg,
    var(--star-background) var(--percent),
    var(--star-color) var(--percent)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.like-ps {
  top: 0px !important;
  left: 2px !important;
}
.primarylists {
  /* padding-top: 10px; */
}
.primarylists > ul > li {
  padding-bottom: 50px;
  overflow: hidden;
}
.vn .primarylists .lessons ul li > div {
  display: flex;
  flex-direction: column;
}
.vn .primarylists .lessons ul .category > div {
  padding: 0px;
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
}
.primarylists ul li .titles {
  height: 35px;
  width: 1000px;
  padding-bottom: 5px;
  color: black;
  margin-bottom: 10px;
  display: flex;
  inline-size: max-content;
}
.primarylists ul li .titles img {
  width: 32px;
  height: 32px;
  margin-top: 1px;
}
.primarylists ul li .titles .title {
  font-size: 24px;
  padding: 0 20px 0 10px;
  line-height: 35px;
  cursor: pointer;
  font-weight: bold;
}
.primarylists ul li .titles .more {
  font-size: 16px;
  line-height: 35px;
  cursor: pointer;
  padding-right: 20px;
}
.primarylists ul li .titles .more a {
  color: black;
}
.more a {
  color: #fff !important;
}
.primarylists ul li .titles .title:hover {
  color: #02adff;
}
.primarylists ul li .titles .more :hover {
  color: #02adff;
}
.primarylists .secondlist {
  height: 100%;
  font-size: 16px;
}
.primarylists .secondlist ul li {
  float: left;
  padding: 3px 10px;
  cursor: pointer;
  margin-right: 16px;
  background: #666;
  border-radius: 15px;
  color: white;
}
.primarylists .secondlist ul li.choose {
  background: lightskyblue;
}
.primarylists .lessons ul {
  justify-content: center;
  height: auto;
  overflow: hidden;
  transform: translateX(5px);
}
.primarylists .lessons ul li {
  width: 350px;
  height: auto;
  float: left;
  box-sizing: border-box;
  background: #333;
  background-clip: padding-box;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
  border-color: #fff !important;
  /* background-color: #f1f1f1 !important; */
  box-shadow: 0px 1px 7px 1px rgb(0 0 0 / 20%) !important;
  border: #dadae8;
}
.primarylists .lessons ul .category {
  width: 350px;
  height: auto;
  float: left;
  box-sizing: border-box;
  background: #333;
  background-clip: padding-box;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
  border-color: #fff !important;
  /* background-color: #f1f1f1 !important; */
  box-shadow: 0px 1px 7px 1px rgb(0 0 0 / 20%) !important;
  border: #dadae8;
}
.primarylists .lessons ul li .img {
  height: 150px !important;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}
.primarylists .lessons ul .category .img {
  max-height: 223px !important;
  height: auto !important;
  width: 100% !important;
  overflow: hidden;
}
.primarylists .lessons ul li .img img {
  width: auto;
  object-fit: inherit;
  transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -webkit-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
}
.primarylists .lessons .lessontitle {
  padding: 10px 10px 0px 10px !important;
  margin: 5px 0 0px !important;
  color: #000 !important;
  font-size: 15px;
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.primarylists .lessons ul .category .img img {
  width: 100%;
  transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -webkit-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
}
.primarylists .lessons .category .lessontitle {
  padding: 0px !important;
  margin: 5px !important;
  color: #f8f8f8;
  font-size: 15px;
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.primarylists .lessons .lessontitle:hover {
  color: lightskyblue;
}
.primarylists .lessons .startAndPrice {
  padding: 5px 10px !important;
  margin: 5px 0px 5px 0px !important;
}
.primarylists .lessons .startAndPrice .priceIndex {
  font-size: 18px;
  font-weight: 700;
  color: #0071c1;
}
.primarylists .lessons .introduce {
  padding: 0 10px;
  color: #999;
  font-size: 12px;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.primarylists .lessons .islike {
  float: right;
  margin: 2px 10px 3px 0px;
  color: #f8f8f8;
  font-size: 10px;
  cursor: pointer;
  overflow: hidden;
  background: #ff0000 !important;
}
.primarylists .lessons .lessontitle_PC {
  height: 50px;
}
.primarylists .lessons .category .lessontitle_PC {
  height: auto;
}

.hot-position {
  padding: 5px 10px;
  border-radius: 10px;
  background: #f32b2b;
  color: #fff;
  margin: 10px;
  font-weight: 600;
}
.button-sub {
  text-align: center;
  padding: 10px 20px;
  display: block;
  border: 1px solid #000;
  border-radius: 5px;
  margin: 0px 10px;
  font-size: 16px;
  color: #000;
  font-weight: 600;
  cursor: pointer;
}
.pagination-course .el-pagination {
  justify-content: center;
}
.pagination-course-category .el-pagination {
  justify-content: center;
}
.button-sub:hover {
  background-color: #0071c1;
  color: #ffffff;
  border: 0;
}
.primarylists .lessons .islike span {
  float: right;
}
.islike div {
  font-size: 12px;
  font-weight: bold;
}
.container,
.bigCourse {
  width: 1200px;
  margin: 0 auto;
}
.free-course {
  color: #cb0d0d;
  padding-right: 20px;
}
@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .container,
  .bigCourse {
    width: 1000px;
  }
}
@media screen and (min-width: 800px) and (max-width: 1000px) {
  .container,
  .bigCourse {
    width: 800px;
  }
}
@media screen and (min-width: 600px) and (max-width: 800px) {
  .container,
  .bigCourse {
    width: 600px;
  }
}
@media screen and (max-width: 600px) {
  .primarylists .lessons ul li .img {
    height: auto !important;
  }
  .container,
  .bigCourse {
    width: 400px;
  }
  .title-course {
    padding: 0px 20px 20px 20px;
  }
}
.vaa :hover {
  transform: scale(1.05, 1.05);
  cursor: pointer;
}
.disabledCourse {
  display: none;
}
.primarylists .lessons .lessontitle_MB {
  display: none;
}
/* style MB */
@media (max-width: 480px) {
  .primarylists .lessons.lessons-new ul li {
    width: calc(100% - 10px) !important;
  }
  .el-pager .number {
    height: 30px !important;
  }
  .primarylists .lessons .borderIndex {
    border-bottom: none !important;
  }
  .primarylists .lessons .startAndPrice .priceIndex {
    float: none !important;
  }
  .Stars {
    --star-size: 20px !important;
  }
  .primarylists .lessons .lessontitle {
    padding: 0px 5px 0px 5px !important;
    margin: 0px 0 15px !important;
    /* height: 35px; */
  }
  .vn .primarylists .lessons .lessontitle {
    color: #000 !important;
    width: 100% !important;
    height: 50%;
  }
  .primarylists .lessons .lessontitle_PC {
    display: none !important;
  }
  .primarylists .lessons .lessontitle_MB {
    display: unset !important;
  }
  .primarylists .lessons .lessontitle_MB div {
    height: auto;
  }
  .primarylists .lessons .startAndPrice {
    margin: 0 !important;
  }
  .priceIndex {
    padding: 0px 5px 0px 5px !important;
  }
  .startIndex {
    padding: 0px 5px 0px 5px !important;
  }
  .button-sub {
    float: right;
    padding: 5px 10px;
  }
  .vn .primarylists .lessons.lessons-new ul li {
    height: 100px !important;
  }
  .primarylists .lessons .lessontitle {
    margin: 1px;
    height: 37px;
    padding: 10px 5px 0px 15px !important;

    margin: 0px !important;
  }
  .vn .primarylists .lessons ul li > div {
    padding: 0px;
    flex-direction: row;
  }
  .vn .primarylists .lessons ul li > div > div {
    width: 64%;
  }
  .vn .primarylists .lessons ul .category > div > div {
    width: 100%;
  }
  .vn .primarylists .lessons.lessons-new ul .category {
    width: calc(50% - 16px) !important;
    height: 50px !important;
  }
}

@media screen and (min-width: 481px) and (max-width: 710px) {
  .primarylists .lessons .startAndPrice .priceIndex {
    float: none !important;
    height: 45px;
  }
  .button-sub[data-v-081e9a2d] {
    padding: 5px 10px;
    border-radius: 5px;
    margin: 0px 5px;
  }
  .vn .primarylists .lessons ul li .img {
    height: 100px !important;
  }
  .primarylists .lessons.lessons-new ul li {
    height: auto;
  }
}
.select-new-questions {
  display: flex;
  align-items: center;
  justify-content: end;
}
.select-new-questions p {
  font-size: 16px;
  color: #033c7f;
  font-weight: 600;
}
.questions_type {
  margin: 10px;
  height: 36px;
  width: 170px;
  border: 1px solid #033c7f;
  border-radius: 5px;
  background: #fff;
  cursor: pointer;
  font-size: 16px;
  color: #033c7f;
}
.my_select_organization_disabled {
  color: #033c7f;
}
.my_select_organization_disabled .ds {
  color: #202122 !important;
}
@media (max-width: 1112px) {
  .manage--content .btn-next-1 {
    z-index: 1001;
    display: none;
  }
}
/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 3; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 60%;
  border-radius: 10px;
  position: relative;
}

/* The Close Button */
.close {
  color: #fff;
  float: right;
  font-size: 15px;
  font-weight: bold;
  border: 1px solid;
  /* border-color: gray; */
  border-radius: 7px;
  padding: 5px;
  background-color: #25368c;
  cursor: pointer;
  position: absolute;
  right: 5px;
  top: 5px;
}

/* .close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
} */
.modal-content .item-image img {
  width: 100px;
}
.modal-content .item-close {
  font-size: 30px !important;
  cursor: pointer;
  color: #cb0d0d;
}
.modal-content .item-total p {
  font-size: 20px;
  padding: 10px 0px;
  border-top: 1px solid #0071c5;
  text-align: right;
}
.modal-content .item-total span {
  color: #cb0d0d;
}
.modal-content .cart-content .submit {
  padding: 10px 20px;
  background: #0071c5;
  border: none;
  color: #ffff;
  font-size: 20px;
  border-radius: 5px;
  display: block;
  margin: 0px auto;
  cursor: pointer;
}
.modal-content .cart-content .empty-cart {
  display: block;
  margin: 10px auto;
}
.shopping-cart .button-icon {
  position: fixed;
  right: 25px;
  bottom: 10px;
  z-index: 10;
}
.shopping-cart .button-icon img {
  width: 60px;
  cursor: pointer;
}
.shopping-cart .button-icon .total-item-cart {
  background-color: #ffff;
  border: 1px solid #000;
  padding: 5px;
  border-radius: 20px;
  position: absolute;
  right: 40px;
  top: 0px;
  z-index: 1000;
}
.modal-content .cart-content .cart-table td {
  font-size: 16px;
}
.modal-content .cart-content .cart-table td .item-price-cart {
  color: #cb0d0d;
}
/* Price */
.style-1 del {
  color: blue;
  text-decoration: none;
  position: relative;
  font-size: 25px;
  font-weight: 700;
}
.style-1 del ::before {
  content: " ";
  display: block;
  width: 100%;
  border-top: 2px solid #cb0d0d;
  height: 12px;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: rotate(-7deg);
}
ins {
  color: #cb0d0d;
  font-size: 35px;
  text-decoration: none;
  padding: 1em 1em 1em 0.5em;
  font-weight: 700;
}
@media only screen and (max-width: 1100px) {
  .flex-container > .media-teacher {
    width: 30%;
  }
  /* Price */
  .style-1 del {
    font-size: 20px;
  }
  ins {
    font-size: 25px;
  }
  .modal-content .cart-content .cart-table td {
    font-size: 16px;
    display: block;
  }
  .modal-content .cart-content .cart-table .item-close {
    width: 10%;
    position: relative;
    top: -85px;
    left: 90%;
    z-index: 1;
  }
}
@media only screen and (max-width: 1200px) {
  .shopping-cart .button-icon {
    position: fixed;
    right: 10px;
    bottom: 60px;
    z-index: 10;
  }
}
@media only screen and (max-width: 600px) {
  .cart-content {
    height: 450px;
    overflow-y: scroll;
  }
  .detail_info-course .box-info span #sub {
    width: 80%;
  }

  /* Modal Content */
  .modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 90%;
  }
  .modal-content .cart-content .cart-table td {
    display: block;
    font-size: 16px;
  }
  .lesson_content tr td {
    padding: 10px;
    font-size: 14px;
  }
  /* Price */
  .style-1 del {
    font-size: 20px;
  }
  ins {
    font-size: 25px;
  }
}
/* Scroll style */
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(96, 183, 241);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #b30000;
}
.cart_moblie {
  width: unset !important;
}
.loading--lesson {
  position: absolute;
}
.nqt-pst-a {
  position: absolute !important;
}
</style>



// WEBPACK FOOTER //
// src/components/defineSelfCourse/content/contentSelfCourse.vue